import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              漫画分类
            </h2>
            <p className="text-sm text-foreground-500 mt-2">探索你喜欢的漫画类型</p>
          </div>
          <Link
            to="/category/action"
            className="text-sm text-accent-500 hover:text-accent-600 transition-colors duration-200 whitespace-nowrap flex items-center gap-1"
          >
            查看全部分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-lg bg-background-100 border border-background-200/60 hover:border-accent-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name}漫画`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-4 right-4">
                  <div className="flex items-center gap-2">
                    <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500/90 text-background-50">
                      <i className={`${cat.icon} text-sm`}></i>
                    </span>
                    <span className="text-background-50 font-semibold text-base">{cat.name}</span>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <p className="text-xs text-foreground-500 leading-relaxed">{cat.description}</p>
                <p className="text-xs text-foreground-400 mt-2">{cat.count.toLocaleString()} 部作品</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}